import React from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, FileText, Briefcase, Mail, LogOut, PenSquare, Images } from 'lucide-react';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const navItems = [
    { to: '/admin/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { to: '/admin/projects', icon: <Briefcase size={20} />, label: 'Projects' },
    { to: '/admin/blogs', icon: <FileText size={20} />, label: 'Blog & News' },
    { to: '/admin/pages', icon: <PenSquare size={20} />, label: 'Edit Pages' },
    { to: '/admin/carousel', icon: <Images size={20} />, label: 'Carousel' },
    { to: '/admin/contacts', icon: <Mail size={20} />, label: 'Contacts' },
  ];

  return (
    <div className="min-h-screen bg-surface" data-testid="admin-layout">
      {/* Top Nav */}
      <div className="bg-white border-b border-border fixed top-0 left-0 right-0 z-40">
        <div className="flex items-center justify-between h-16 px-6">
          <div className="flex items-center space-x-4">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/files/invictus-green/uploads/974218eb-5249-49d9-9fa5-bef235aac409.png`}
              alt="Logo"
              className="h-20 w-auto"
            />
            <span className="text-xl font-semibold text-primary">Admin Panel</span>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-text_muted" data-testid="admin-user-email">{user?.email}</span>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 px-4 py-2 bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors"
              data-testid="admin-logout-button"
            >
              <LogOut size={18} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar + Content */}
      <div className="flex pt-16">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-border fixed left-0 top-16 bottom-0 overflow-y-auto" data-testid="admin-sidebar">
          <nav className="p-4 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`flex items-center space-x-3 px-4 py-3 rounded transition-colors ${
                  location.pathname === item.to
                    ? 'bg-accent text-white'
                    : 'text-text_main hover:bg-surface'
                }`}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {item.icon}
                <span className="font-medium">{item.label}</span>
              </Link>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 ml-64 p-8" data-testid="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
